import { Modal, PrimaryButton, SecondaryButton } from '@steinpilz/react-ux-business-app';
import { useTranslation } from '@steinpilz/react-ux-i10n';
import { useUnit } from 'effector-react';

import { $unsavedChangesDialog, hideUnsavedChangesDialog } from '@infrastructure/unsaved-changes/stores/dialog';

export const UnsavedChangesDialog: React.FC = () => {
  const t = useTranslation();
  const { isOpen, pendingAction } = useUnit($unsavedChangesDialog);

  const confirm = () => {
    pendingAction?.();
    hideUnsavedChangesDialog();
  };

  return (
    <Modal
      zIndex={Number.MAX_SAFE_INTEGER}
      open={isOpen}
      onOk={confirm}
      onCancel={() => hideUnsavedChangesDialog()}
      title={t('NotSavedChanges.Title')}
      footer={
        <>
          <SecondaryButton onClick={() => hideUnsavedChangesDialog()} data-testid="cancel">
            {t('Buttons.Cancel')}
          </SecondaryButton>
          <PrimaryButton onClick={confirm} data-testid="ok">
            {t('Buttons.Ok')}
          </PrimaryButton>
        </>
      }
    >
      {t('NotSavedChanges.Description')}
    </Modal>
  );
};
